// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"o3-z","dimensionLabel":"p3-z","styleChooserControlWrapper":"q3-z","styleChooserControl":"r3-z","disabled":"s3-z","giftCard":"t3-z","styleChooserText":"u3-z"};